import axios from 'axios'

export default {
  getConversations () {
    return axios.get('/conversations')
  },
  getConversationMessages (conversationId: string) {
    return axios.get(`/conversations/${conversationId}/messages`)
  },
  postPrompt (mnemo: string, prompt: string, conversationId: string | null) {
    return axios.post(`/room/${mnemo}/ai-ask`, { prompt, conversationId })
  },
}
